import { render } from "./WalletConnectInfoModal.vue?vue&type=template&id=51a669b4&scoped=true"
import script from "./WalletConnectInfoModal.vue?vue&type=script&lang=js"
export * from "./WalletConnectInfoModal.vue?vue&type=script&lang=js"

import "./WalletConnectInfoModal.vue?vue&type=style&index=0&id=51a669b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a669b4"]])

export default __exports__